<template>
  <div class="relative flex-shrink-0">
    <img v-if="user.avatar" :src="user.avatar" class="w-9 h-9 rounded-full object-cover" />
    <img v-else src="../../assets/logos/refrag-avatar.svg" alt="" class="w-9 h-9 rounded-full object-cover" />
    <span
      v-if="online"
      class="absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full bg-green-400 border-2 border-gray-950"
    />
  </div>
</template>

<script setup>
defineProps({
  user: { type: Object, required: true },
  online: { type: Boolean, default: false },
});
</script>
